
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    metadata: Object
  },
  computed: {
    locationString() {
      if (this.metadata.location.startsWith("kindle")) return "Kindle";
      if (this.metadata.location.includes(":8083")) return "Digital Library";
      if (this.metadata.location.startsWith("http")) {
        const url = new URL(this.metadata.location);
        return url.hostname;
      }
    }
  }
})
export default class Book extends Vue {
  metadata!: object;
}
